import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../lib/cn";
const spinnerVariants = cva("animate-spin rounded-full border-b-2", {
    variants: {
        variant: {
            default: "border-primary",
            white: "border-white",
            muted: "border-muted-foreground",
            info: "border-info",
            destructive: "border-destructive",
        },
        size: {
            sm: "h-4 w-4",
            default: "h-8 w-8",
            lg: "h-12 w-12",
            inline: "h-6 w-6",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
function Spinner({ className, variant, size, ...props }) {
    return (_jsx("div", { role: "status", "aria-label": "Loading", className: cn(spinnerVariants({ variant, size }), className), ...props }));
}
export { Spinner, spinnerVariants };
